import {
    TOP_FEATURE_DELETE_START,
    TOP_FEATURE_DELETE_SUCCESS,
    TOP_FEATURE_DELETE_ERROR
} from "../../../constants";
import { deleteTopFeatureMutation as mutation, getAllHomePageCategorySettings as query } from "../../../lib/graphql";
import { setLoaderStart, setLoaderComplete } from "../../loader/loader";
import { showToaster } from "../../../helpers/toastrMessgaes/showToaster";

const deleteTopFeature = (id,) => {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: TOP_FEATURE_DELETE_START
            });

            dispatch(setLoaderStart('DeleteTopFeature'));

            const { data } = await client.mutate({
                mutation,
                variables: { id },
                refetchQueries: [{ query }]
            })
            dispatch(setLoaderComplete('DeleteTopFeature'));

            if (data?.deleteTopFeature?.status == 200) {
                dispatch({
                    type: TOP_FEATURE_DELETE_SUCCESS
                });
                showToaster({ messageId: 'deleteTopFeatureSuccess', toasterType: 'success' });
            } else {
                dispatch({
                    type: TOP_FEATURE_DELETE_ERROR
                });
                showToaster({ messageId: 'errorMessage', requestContent: data?.deleteTopFeature?.errorMessage, toasterType: 'error' });
            }
        } catch (error) {
            dispatch({
                type: TOP_FEATURE_DELETE_ERROR
            });
            showToaster({ messageId: 'errorMessage', requestContent: error, toasterType: 'error' });
        }
    }
}

export default deleteTopFeature;